/** @jsxImportSource @emotion/react */
import React from 'react';
import { screenReaderOnlyStyle } from '../utils/styles';

const ScreenReaderOnly = ({ children }: { children: React.ReactNode }) => {
  return <span css={screenReaderOnlyStyle}>{children}</span>;
};

export default ScreenReaderOnly;
